export const companyFilesTranslation = {
  en: {
    "Company Files": "Company Files",
    "Add File": "Add File",
    "Edit File": "Edit File",
    Delete: "Delete",
    Search: "Search",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    URL: "URL",
    File: "File",
    Status: "Status",
    Active: "Active",
    Inactive: "Inactive",
    "Are you sure you want to delete membership '{{name}}'?":
      "Are you sure you want to delete membership '{{name}}'?",
    "Are you sure you want to delete file '{{name}}'?":
      "Are you sure you want to delete file '{{name}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "created at": "Created At",
    actions: "Actions",
    "Update File": "Update File",
    "Add New File": "Add New File",
    Cancel: "Cancel",
  },
  ar: {
    "Company Files": "ملفات الشركة",
    "Add File": "إضافة ملف",
    "Edit File": "تعديل ملف",
    Delete: "حذف",
    Search: "بحث",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    URL: "الرابط",
    File: "الملف",
    Status: "الحالة",
    Active: "نشط",
    Inactive: "غير نشط",
    "Are you sure you want to delete membership '{{name}}'?":
      "هل أنت متأكد أنك تريد حذف العضوية '{{name}}'؟",
    "Are you sure you want to delete file '{{name}}'?":
      "هل أنت متأكد أنك تريد حذف الملف '{{name}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "created at": "تاريخ الإنشاء",
    actions: "الإجراءات",
    "Update File": "تحديث الملف",
    "Add New File": "إضافة ملف جديد",
    Cancel: "إلغاء",
  },
};
